import axios from './axiosConfig';
import { API_BASE_URL } from './axiosConfig';

export const fetchSummaryGraphs = async (period) => {
	try {
		const response = await axios.post(
			`${API_BASE_URL}/summary/chart`,
			period,
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem('access_token')}`,
				},
			});
		return response.data;
	} catch (error) {
		console.error('Error fetching summary chart:', error);
		throw error;
	}
}

export const fetchSummaryPdf = async (data) => {
	try {
		const response = await axios.post(
			`${API_BASE_URL}/summary/pdf`,
			data,
			{	
				responseType: 'json',
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem('access_token')}`,
				},				
			});
		return response.data;
	} catch (error) {
		console.error('Error fetching summary pdf:', error);
		throw error;
	}
}